import React from "react";
import styled from "styled-components";

const Title = styled.div`
  font-size: 16pt;
  color: #999999;
  width: 100%;
  margin-bottom: 4px;
  padding-right: 0px;

`;
const FormSectionTitle = ({ title }) => (
  <Title>
    {title}
  </Title>
);
export default FormSectionTitle;
